import React, { useId, useState } from 'react';
import { MapPinIcon } from 'lucide-react';
import { addressSuggestions } from '../../data/demandes';
interface AddressAutocompleteProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
  className: string;
}

/** Champ d'adresse avec suggestions filtrées en direct (combobox accessible). */
export function AddressAutocomplete({
  id,
  value,
  onChange,
  invalid,
  className
}: AddressAutocompleteProps) {
  const listId = useId();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const query = value.trim().toLowerCase();
  const matches = query ? addressSuggestions.filter(item => item.toLowerCase().includes(query)).slice(0, 6) : addressSuggestions.slice(0, 6);
  const expanded = open && matches.length > 0;
  const pick = (address: string) => {
    onChange(address);
    setOpen(false);
    setActive(-1);
  };
  return <div className="relative" data-id="element-1077" data-mp="28ln1mennfubp">
      <input id={id} role="combobox" aria-autocomplete="list" aria-expanded={expanded} aria-controls={listId} aria-activedescendant={expanded && active >= 0 ? `${listId}-${active}` : undefined} aria-invalid={invalid || undefined} autoComplete="off" value={value} onChange={event => {
      onChange(event.target.value);
      setOpen(true);
      setActive(-1);
    }} onFocus={() => setOpen(true)} onBlur={() => window.setTimeout(() => setOpen(false), 120)} onKeyDown={event => {
      if (event.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (!expanded) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(current => (current + 1) % matches.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(current => current <= 0 ? matches.length - 1 : current - 1);
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        pick(matches[active]);
      }
    }} className={className} data-id="element-1078" data-mp="28mewfn9f9o0x" />
      {expanded && <ul id={listId} role="listbox" className="absolute inset-x-0 top-full z-20 mt-1 overflow-hidden rounded-xl border border-slate-200 bg-white py-1 shadow-lg shadow-ville-navy/10" data-id="element-1079" data-mp="95qvxq37xohh">
          {matches.map((address, index) => <li key={address} id={`${listId}-${index}`} role="option" aria-selected={index === active} onMouseDown={event => {
        event.preventDefault();
        pick(address);
      }} onMouseEnter={() => setActive(index)} className={`flex cursor-pointer items-center gap-2.5 px-3.5 py-2.5 text-sm text-ville-navy ${index === active ? 'bg-ville-indigo-soft' : ''}`} data-id="element-1080" data-mp="3qee4z420bvuc" data-mpi={index}>
              <MapPinIcon className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-1081" data-mp="1n5u9h8r0gxn8" />
              {address}
            </li>)}
        </ul>}
    </div>;
}